import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ForgetPasswordComponent } from '../../../../modules/identity-area/auth/pages/forget-password/forget-password.component';
import { LoginComponent } from '../../../../modules/identity-area/auth/pages/login/login.component';
import { SignUpComponent } from '../../../../modules/identity-area/auth/pages/sign-up/sign-up.component';
import { VerifyEmailComponent } from '../../../../modules/identity-area/auth/pages/verify-email/verify-email.component';
import { ModalComponent } from '../modal/modal.component';
import { AuthModalService } from './auth-model.service';
import { SharedModule } from '../../../shared-module';
@Component({
  selector: 'app-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrl: './auth-modal.component.scss',
  imports: [
    CommonModule,
    LoginComponent,
    SignUpComponent,
    ForgetPasswordComponent,
    VerifyEmailComponent,
    ModalComponent,
    SharedModule
  ],
  providers: [AuthModalService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthModalComponent implements OnInit, OnChanges {
  @Input() loginDescription?: string;
  @Output() onClose = new EventEmitter();
  constructor(public authModalService: AuthModalService) {
    authModalService.isInModal = true;
  }

  ngOnInit() {
    this.authModalService.onClose.subscribe(() => {
      this.onClose.emit();
    });
  }

  ngOnChanges() {
    this.authModalService.loginDescription = this.loginDescription;
  }
}
